import { Box } from '@material-ui/core';
import React, { useEffect } from 'react';

import PageContent from '../../../../../components/Layout/PageContent';
import { TableGridApiContextProvider } from '../../../../../components/TableGrid/TableGridApiContext/TableGridApiContext';
import {
  useCompaniesDispatch,
  useCompaniesState,
} from '../../../../FinancialData/shared/CompanyContext/CompanyContext';
import { CompanyContextActionTypes } from '../../../../FinancialData/shared/CompanyContext/CompanyContext.types';
import { useBenchmarkDispatch, useBenchmarkState } from '../../../Context/BenchmarkContext';
import { BenchmarkContextActionTypes } from '../../../Context/BenchmarkContext.types';
import CompanyBlock from './CompanyBlock';
import { SearchPanel, SearchPanelCM } from './SearchPanel';

const CompanyResolvePage: React.FC = () => {
  const { companies, activeCompanyId, activeBenchmark } = useBenchmarkState();
  const dispatchBenchmark = useBenchmarkDispatch();
  const { company } = useCompaniesState();
  const dispatch = useCompaniesDispatch();
  const isBenchwiseStudy = !!activeBenchmark?.benchwiseStudy;

  useEffect(() => {
    const firstCompanyId = companies.length > 0 && companies[0]?.companyInfo?.id;
    if (firstCompanyId && !activeCompanyId) {
      dispatchBenchmark({
        type: BenchmarkContextActionTypes.SetActiveBenchmarkCompanyId,
        payload: firstCompanyId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, companies]);

  useEffect(() => {
    if (activeCompanyId) {
      const filteredCompany = companies.find((c) => activeCompanyId === c.companyInfo?.id);
      if (filteredCompany) {
        dispatch({
          type: CompanyContextActionTypes.SetCompany,
          payload: {
            companyInfo: filteredCompany.companyInfo,
            financialInfo: filteredCompany.financialInfo,
          },
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, companies, activeCompanyId]);

  return (
    <Box>
      <PageContent>
        <TableGridApiContextProvider>
          {isBenchwiseStudy ? <SearchPanelCM /> : <SearchPanel />}
          {activeCompanyId && company?.companyInfo?.id && <CompanyBlock />}
        </TableGridApiContextProvider>
      </PageContent>
    </Box>
  );
};

export default CompanyResolvePage;
